import { useMemo } from "react";

import { useCreateClientMutation } from "@/hooks/useCreateClientMutation";
import { useQueryCashed } from "@/hooks/useQueryCashed";

import { UserSearchLadiesApi } from "../api";
import { SearchPageQueryParams } from "../models";

export const useSearchLadies = ({
  urlSearchParams,
  ...params
}: SearchPageQueryParams) => {
  const queryKey = useMemo(
    () => ["LADIES_SEARCH", { params, urlSearchParams }] as const,
    [params, urlSearchParams],
  );

  const queryCachedValue = useQueryCashed({
    queryKey,
    queryFn: () => {
      return UserSearchLadiesApi.get({ ...params, urlSearchParams });
    },
    enabled: Boolean(urlSearchParams),
  });

  const { clientMutation: toggleLadyFavorite } = useCreateClientMutation(
    queryKey,
    UserSearchLadiesApi.get,
    (data) => (id: number) => {
      return {
        ...data,
        itemArray: data.itemArray.map((lady) => {
          if (lady.id === id) {
            return { ...lady, isFavorite: !lady.isFavorite };
          }

          return lady;
        }),
      };
    },
  );

  return { ...queryCachedValue, clientMutations: { toggleLadyFavorite } };
};
